// Generated from the TokenTax Icons Figma Final page. Do not edit.
import * as React from 'react';
import type { IconProps } from './types';
import { Ref, forwardRef } from 'react';
const Approval = ({ size, ...props }: IconProps, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
    ref={ref}
    {...props}
  >
    <path stroke="currentColor" strokeLinecap="square" strokeWidth={1.125} d="M2.813 16.031h12.375" />
    <path
      stroke="currentColor"
      strokeWidth={1.125}
      d="m8.038 9.844-1.25-5.836a1.688 1.688 0 0 1 1.65-2.04h1.124a1.687 1.687 0 0 1 1.65 2.04l-1.25 5.836"
    />
    <path
      stroke="currentColor"
      strokeLinecap="square"
      strokeWidth={1.125}
      d="M12.938 9.844H5.062a2.25 2.25 0 0 0-2.25 2.25v1.687h12.376v-1.687a2.25 2.25 0 0 0-2.25-2.25Z"
    />
  </svg>
);
const ForwardRef = forwardRef(Approval);
export default ForwardRef;
